import _ from 'lodash';
import JsonPlaceholder from "../apis/JsonPlaceholder";

export const fetchPostsAndUsers = () => async (dispatch, getState) => {
    //console.log('about fetched posts');
     await dispatch(fetchPosts());
    // //console.log('fetched posts');
     const userIds = _.uniq(_.map(getState().posts, 'userId'));
    // //console.log(userIds);
     userIds.forEach(id => dispatch(fetchUser(id)));

    // _.chain(getState().posts)
    //     .map('userId')
    //     .uniq()
    //     .forEach(id => dispatch(fetchUser(id)))
    //     .value();

}

export const fetchPosts = () =>  async dispatch => {
       const response = await JsonPlaceholder.get('/posts');

        dispatch({ type: 'FETCH_POSTS', payload: response.data });
}
    
export const fetchUser = id => async dispatch =>{
    const response = await JsonPlaceholder.get(`/users/${id}`);
    dispatch({ type: 'FETCH_USER', payload: response.data });
}
//Memoized version approach
// export const fetchUser = id => dispatch => _fetchUser(id , dispatch);
// export const _fetchUser = _.memoize(async(id, dispatch) => {
//     const response = await JsonPlaceholder.get(`/users/${id}`);

//     dispatch({ type: 'FETCH_USER', payload: response.data });
// });